import { useTranslation } from 'react-i18next';
import { SButton } from './styled';

export default function CancelButton(props) {
  const { t } = useTranslation();
  return <SButton {...props}>{t('Cancel')}</SButton>;
}
